export default [
  {
    position: "absolute",
    top: 9.5,
    left: 54,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona3.mTitleTwo",
    mBody: "homeDashboard.persona3.mBodyTwo",
    isVideo: true,
    videoThumb: "HR-Home-Thumb",
    videoURL: "HR-Homepage.mp4",
    vidIcon: true,
    id: "HR_Homepage_Video_PersonalizedHomepage",
    index: 0,
  },
  {
    position: "absolute",
    top: 18,
    left: 36,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona3.mTitleFour",
    mBody: "homeDashboard.persona3.mBodyFour",
    id: "HR_Homepage_Info_TailoredDashboards",
    infoIcon: true,
    isAction: false,
    index: 1,
  },
  {
    position: "absolute",
    top: 51.8,
    left: 77,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-bottom-right",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona3.mTitleFive",
    mBody: "homeDashboard.persona3.mBodyFive",
    id: "HR_Homepage_Info_InboundRequests",
    infoIcon: true,
    isAction: false,
    index: 2,
  },
  {
    position: "absolute",
    top: 1.6,
    left: 20,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona3.mTitleOne",
    mBody: "homeDashboard.persona3.mBodyOne",
    id: "HR_Homepage_Info_EmployeeView",
    infoIcon: true,
    isAction: false,
    index: 3,
  },
  {
    position: "absolute",
    top: 1.9,
    left: 27.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "homeDashboard.persona3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Homepage_Navigation_TeamMember",
    index: 4,
  },
  {
    position: "absolute",
    top: 1.9,
    left: 34.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "homeDashboard.persona3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_Homepage_Navigation_Dashboard",
    index: 5,
  },
  {
    position: "absolute",
    top: 1.9,
    left: 39.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "homeDashboard.persona3.ttTextTwo",
    hover: false,
    id: "HR_Homepage_Navigation_Reports",
    index: 6,
  },
  {
    position: "absolute",
    top: 3.4,
    left: 0.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "homeDashRecruitP3.open",
    hover: false,
    tooltipClass: "right",
    id: "HR_Homepage_Navigation_Recruit",
    index: 7,
  },
];
